import React from 'react';

const NotFoundPage = () => {
  return (
    <div> 404 NotFound</div>
  );
};

export default NotFoundPage;
